<template>
  <div class="subsystemTreeMenu">
    <el-select
      v-model="value"
      style="width: 100%"
      v-if="$route.path == '/powerQuality'"
      @change="getElectricEnergyParams"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <div style="width: 100%; height: 80%; margin: 10px 0 20px 0">
      <el-input placeholder="请输入关键字" v-model="filterText"></el-input>
      <el-tree
        :data="treeData"
        :props="defaultProps"
        accordion
        :default-expanded-keys="defaultKeys"
        :filter-node-method="filterNode"
        node-key="id"
        highlight-current
        ref="tree"
        style="
          overflow: auto;
          background: #f7f7f7;
          border: 1px solid #e7e7e7;
          border-radius: 6px;
          padding: 20px 0 30px;
          margin-top: 10px;
          height: 80%;
        "
      ></el-tree>
    </div>
    <div class="buttons">
      <el-button type="primary" style="width: 100%" @click="onSubmit"
        >确 认
      </el-button>
    </div>
  </div>
</template>

<script>
import api from "@/api";
export default {
  props: {
    pageName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      treeData: [],
      defaultData: {}, //默认选中的第一个数据
      defaultKeys: [], //默认打开
      defaultProps: {
        children: "children",
        label: "name",
      },
      filterText: "",
      options: [
        { value: "Harmonic", label: "谐波监测" },
        { value: "Imbalance", label: "三相不平衡度" },
      ],
      value: "Harmonic",
      harmonicParameter: [],
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  methods: {
    handleEmit() {
      if (this.$route.path == "/powerQuality") {
        this.$emit(
          "getActiveItem",
          Object.assign({}, this.$refs.tree.getCurrentNode(), {
            treeValue: this.value,
            harmonicParameter: this.harmonicParameter,
          })
        );
      } else if (this.$route.path == "/buildingInfor") {
        let treeNode = this.$refs.tree.getNode(
          this.$refs.tree.getCurrentNode()
        );

        let treeTitle = "";
        function getTreeNode(node) {
          treeTitle = node.data.name + treeTitle;
          if (node.parent && node.level !== 1) {
            treeTitle = "-" + treeTitle;
            getTreeNode(node.parent);
          }
        }
        getTreeNode(treeNode);
        this.$emit(
          "getActiveItem",
          Object.assign({}, this.$refs.tree.getCurrentNode(), { treeTitle })
        );
      } else {
        this.$emit("getActiveItem", this.$refs.tree.getCurrentNode());
      }
    },
    onSubmit() {
      if (!this.$refs.tree.getCurrentKey()) {
        this.$message.error("请选择资产");
        return;
      }
      this.handleEmit();
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    getAsseList() {
      let treeAllData = JSON.parse(
        window.sessionStorage.getItem("assetsAllData")
      );
      this.treeData = [treeAllData.区域位置];
      this.defaultData = this.treeData[0];
      this.setDefaultActive();
    },
    async getDynamicalAssetTree() {
      let _this = this;
      let res = await api.DynamicalGetAssetTree({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        assetType: "区域位置",
        option: "HasEUDevice",
        deviceTypes: "直梯,扶梯,加速带",
      });
      if (res && res.status == 200) {
        this.treeData = [res.data];
        function calleArr(array) {
          let data = array[0];
          if (data.children && data.children.length) {
            calleArr(data.children);
          } else {
            _this.defaultData = data;
          }
        }
        calleArr(_this.treeData);
        this.setDefaultActive();
      }
    },
    async getTreeList() {
      let res = await api.lightSystemAssetsTreeMenu({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        projectName: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectName,
        option: "HasEUDevice",
        deviceType: "照明设备",
      });
      if (res && res.status == 200) {
        this.treeData = [res.data.assets.区域位置];
        this.defaultData = this.treeData[0];
        this.setDefaultActive();
      }
    },
    // 配电系统-运行状态、需量分析
    async getDistributingTree() {
      let obj = {
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        maxLevel: 4,
        type: "配电系统",
      };
      if (this.$route.path == "/demandAnalysis") {
        obj = Object.assign({}, obj, {
          deviceTypes: "电表",
          assetLabel: "分项系统",
        });
      }
      let res = await api.photovoltaicTreeList(obj);
      if (res && res.data.code == 200) {
        if (res.data?.data?.assets?.分项系统) {
          this.treeData = res.data.data.assets.分项系统.children ?? [];

          if (this.$route.params.assetId) {
            let result = {};
            function findItemById(arr, id) {
              for (let i = 0; i < arr.length; i++) {
                const item = arr[i];
                if (item.id === id) {
                  result = item;
                  return;
                }
                if (item.children?.length) {
                  findItemById(item.children, id);
                }
              }
            }
            findItemById(this.treeData, this.$route.params.assetId);
            this.defaultData = result.id ? result : this.treeData[0];
          } else {
            this.defaultData = this.treeData[0];
          }

          this.setDefaultActive();
        }
      }
    },
    // 配电系统-电能质量
    async getElectricEnergyParams() {
      this.treeData = [];
      this.defaultData = {};
      this.$refs.tree.setCurrentKey();
      this.defaultKeys = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.PDSGetHarmonicParameters({
        assetId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        key: this.value,
      });
      if (res && res.data.code == 200) {
        this.harmonicParameter = Array.from(res.data.data).map((v) => ({
          name: v.name,
          key: v.key,
          children: v.params ?? [],
        }));
        this.getHarmonicTree();
      }
    },

    async getHarmonicTree() {
      let params = [];
      this.harmonicParameter.map((item) => {
        if (this.value == "Harmonic") {
          item.children.map((v) => {
            params.push(v.key + "_A", v.key + "_B", v.key + "_C");
          });
        } else {
          params.push(
            item.key,
            item.key + "_A",
            item.key + "_B",
            item.key + "_C"
          );
        }
      });
      let res = await api.photovoltaicTreeList({
        projectId: JSON.parse(window.sessionStorage.getItem("userInfo"))
          .projects[0].projectId,
        maxLevel: 4,
        type: "配电系统",
        deviceTypes: "电表",
        assetLabel: "分项系统",
        params: params.join(","),
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        if (res.data?.data?.assets?.分项系统) {
          this.treeData = res.data.data.assets.分项系统.children ?? [];
          this.defaultData = this.treeData[0];
          this.setDefaultActive();
        }
      }
    },

    setDefaultActive() {
      let _this = this;
      this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(_this.defaultData.id);
        this.defaultKeys.push(_this.defaultData.id);
        this.handleEmit();
      });
    },
  },
  created() {
    if (this.pageName == "动力系统") {
      this.getDynamicalAssetTree();
    } else if (this.pageName == "照明系统") {
      this.getTreeList();
    } else if (this.pageName == "配电系统") {
      if (this.$route.path == "/powerQuality") {
        this.$nextTick(() => {
          this.getElectricEnergyParams();
        });
      } else {
        this.getDistributingTree(); //运行状态、需量分析
      }
    } else {
      this.getAsseList();
    }
  },
  mounted() {
    this.$bus.$on("getClickAssetsItem", (item) => {
      if (item.entityId) {
        this.defaultKeys = [];
        this.$nextTick(() => {
          this.$refs.tree.setCurrentKey(item.entityId);
          this.defaultKeys.push(item.entityId);
          this.handleEmit();
        });
      }
    });
  },
  beforeDestroy() {
    this.$bus.$off("getClickAssetsItem");
  },
};
</script>

<style lang="scss" scoped>
.subsystemTreeMenu {
  width: 93%;
  height: 93%;
  margin: 5% auto;
  // overflow: auto;

  ::v-deep
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: $themeColor !important;
    color: #fff;
  }

  .buttons {
    width: 55%;
    margin: 20px auto;
  }
}
</style>
